export const POST_SET_PASSWORD_REQUEST = "POST_SET_PASSWORD_REQUEST";
export const POST_SET_PASSWORD_ERROR = "POST_SET_PASSWORD_ERROR";
export const POST_SET_PASSWORD_SUCCESS = "POST_SET_PASSWORD_SUCCESS";
